import html2canvas from "html2canvas";
import jsPDF from "jspdf";

async function capture(elementId) {
  const el = document.getElementById(elementId);
  if (!el) throw new Error("Nothing to export");
  const canvas = await html2canvas(el, {
    backgroundColor: "#EEF4FC",
    scale: 2,
    useCORS: true,
    logging: false,
    windowWidth: el.scrollWidth,
    windowHeight: el.scrollHeight,
  });
  return canvas;
}

export async function exportPNG(elementId, name = "dashboard") {
  const canvas = await capture(elementId);
  const link = document.createElement("a");
  link.download = `${name}.png`;
  link.href = canvas.toDataURL("image/png");
  link.click();
}

export async function exportPDF(elementId, name = "dashboard") {
  const canvas = await capture(elementId);
  const img = canvas.toDataURL("image/png");
  const pdf = new jsPDF({ orientation: canvas.width > canvas.height ? "landscape" : "portrait", unit: "px", format: [canvas.width, canvas.height] });
  pdf.addImage(img, "PNG", 0, 0, canvas.width, canvas.height);
  pdf.save(`${name}.pdf`);
}

// Item 59: per-widget PDF (snapshot) with optional "Applied filters" footer strip
export async function exportWidgetPDF(elementId, name = "widget", filters = []) {
  const canvas = await capture(elementId);
  const img = canvas.toDataURL("image/png");
  const margin = 24;
  const bannerH = filters && filters.length ? 44 : 0;
  const orient = canvas.width > canvas.height ? "landscape" : "portrait";
  const w = canvas.width + margin * 2;
  const h = canvas.height + margin * 2 + bannerH;
  const pdf = new jsPDF({ orientation: orient, unit: "px", format: [w, h] });
  pdf.setFillColor(241, 243, 249);
  pdf.rect(0, 0, w, h, "F");
  pdf.setTextColor(15, 23, 42);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.text(name, margin, margin);
  pdf.addImage(img, "PNG", margin, margin + 8, canvas.width, canvas.height);
  if (bannerH) {
    const y = margin + canvas.height + 24;
    pdf.setFillColor(255, 255, 255);
    pdf.setDrawColor(230, 234, 243);
    pdf.roundedRect(margin, y - 12, canvas.width, 32, 6, 6, "FD");
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(9);
    pdf.setTextColor(43, 78, 255);
    pdf.text("Applied filters", margin + 10, y + 2);
    pdf.setFont("helvetica", "normal");
    pdf.setTextColor(51, 65, 85);
    pdf.setFontSize(9);
    const text = filters.map((f) => {
      const v = Array.isArray(f.value) ? f.value.join(", ") : String(f.value ?? "");
      return `${f.field || f.key} ${f.op || "eq"} ${v}`;
    }).join("  ·  ");
    const lines = pdf.splitTextToSize(text, canvas.width - 120);
    pdf.text(lines[0] || "", margin + 90, y + 2);
  }
  pdf.save(`${name}.pdf`);
}

// Item 59: JSON export of a widget's query result rows
export function exportWidgetJSON(name, data, filters = []) {
  const payload = {
    exported_at: new Date().toISOString(),
    widget: name,
    applied_filters: (filters || []).map((f) => ({ field: f.field || f.key, op: f.op || "eq", value: f.value })),
    columns: data?.columns || [],
    meta: data?.meta || null,
    rows: data?.rows || [],
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `${name}.json`;
  a.click(); URL.revokeObjectURL(url);
}
